import React, { useMemo } from "react";

import { orderBy } from "lodash";

import useGetPortfolioPlans from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlans";
import { PersonId } from "@fartherfinance/frontend/api/Investment/types";
import { ClientId, PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { DropdownMenuOption } from "@src/sharedComponents/CustomDropdownBase/MenuOptionsWithCheckIfSelected/MenuOptionsWithCheckIfSelected";
import BaseDropdown from "@src/sharedComponents/Dropdown/BaseDropdown";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ModelPickerModal.module.css";

type CustomPortfolioPlans = {
  onSelect: (el: DropdownMenuOption<PortfolioPlanId>) => void;
  curItem?: string;
  curItemId?: string;
  clientId: ClientId;
};

const CustomPortfolioPlans = ({
  onSelect,
  curItem,
  curItemId,
  clientId,
}: CustomPortfolioPlans) => {
  const auth = useRequestAuth();
  const portfolioData = useGetPortfolioPlans(
    {
      basePermissions: ["Private"],
      ownedBy: PersonId.parse(clientId),
      pageSize: "100",
    },
    auth
  );

  const optionsData = useMemo(
    () =>
      orderBy(
        portfolioData.data?.data.map((portfolioPlan) => ({
          id: portfolioPlan.plan.portfolioPlanId,
          label: portfolioPlan.plan.name,
        })),
        [(x) => x.label],
        ["asc"]
      ),
    [portfolioData.data?.data]
  );

  return (
    <BaseDropdown
      title={
        <div className={styles.flexRow}>
          <Text variant="body" color={"textSubtle"}>
            Name
          </Text>
        </div>
      }
      curItemLabel={curItem}
      curItemId={curItemId}
      options={optionsData}
      onSelect={onSelect}
      height={260}
    />
  );
};

export default CustomPortfolioPlans;
